import { RequestConfig } from '@/interface'

const PRIFIX = 'glht/yy/'
const applicationConfig: RequestConfig = {
  // 应用关联企业
  yyGlqy: {
    url: `${PRIFIX}glqy`,
    method: 'post'
  },
  // 新建应用
  yyAdd: {
    url: `${PRIFIX}add`,
    method: 'post'
  },
  // 删除应用
  yyDel: {
    url: `${PRIFIX}delete`,
    method: 'get'
  },
  // 应用列表
  yyList: {
    url: `${PRIFIX}list`,
    method: 'get'
  },
  // 应用企业列表
  yyqyList: {
    url: `${PRIFIX}yyqyList`,
    method: 'post'
  },
  // 修改服务有效期/启用停用
  xgfwyxq: {
    url: `${PRIFIX}xgfwyxq`,
    method: 'post'
  }
}
export default applicationConfig
